import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import CustomTypography from './CustomTypography';
import { Link } from 'react-router-dom';
import EastIcon from '@mui/icons-material/East';
import { getImagePath } from './Actions/FetchContent';

function Submenu({ title, desc, links, image, isVisible, btnLink,btnLabel }) {
    const [activeItem, setActiveItem] = useState(null);
    const [activeSubItem, setActiveSubItem] = useState(null);

    const handleItemClick = (index) => {
        setActiveItem(activeItem === index ? null : index);
    };

    const handleMenuHover = (index) => {
        setActiveItem(activeItem === index ? null : index);
    };

    const subItemhandleItemClick = (SubIndex) => {
        setActiveSubItem(activeSubItem === SubIndex ? null : SubIndex);
    };

    return (
        <Box
            className={`absolute fixed left-0 w-full transition-all duration-300 z-50 ${isVisible ? 'h-[400px] rounded-b-[40px]' : 'h-0'} bg-primaryLight shadow-lg overflow-hidden`}
            style={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)' }}
        >
            <Box className="grid grid-cols-3 gap-10 p-60px max-w-screen-2xl mx-auto">
                {/* Column 1 - Title/Text */}
                <Box className="flex-1 border-r border-gray-300 px-6">
                    <CustomTypography as="p" variant="p2" color="text-customBlack" weightFont="font-semibold">
                        {title}
                    </CustomTypography>
                    <CustomTypography as="p" variant="p3" color="text-SlateGray" weightFont="font-normal" className="pt-4">
                        {desc}
                    </CustomTypography>
                    {btnLink && (
                        <Box className='flex pt-4'>
                            {btnLink.startsWith('http') || btnLink.startsWith('https') ? (
                                <a
                                    href={btnLink}
                                    className="mt-1 inline-block py-2 font-manrope text-topGreen rounded-lg font-semibold text-[18px]"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {btnLabel} <EastIcon style={{ width: '25px', height: '25px' }} />
                                </a>
                            ) : (
                                <Link
                                    to={btnLink}
                                    className="mt-1 inline-block py-2 font-manrope text-topGreen rounded-lg font-semibold text-[18px]"
                                >
                                    {btnLabel} <EastIcon style={{ width: '25px', height: '25px' }} />
                                </Link>
                            )}
                        </Box>
                    )}
                </Box>

                {/* Column 2 - Submenu Links */}
                <Box className="border-r border-gray-300 px-6">
                    <ul className="space-y-1 grid grid-cols-1 gap-3">
                        {links.map((link, index) => {
                            const isExternal = link.path?.startsWith('http');
                            const isActive = activeItem === index;

                            const linkClasses = `font-manrope font-bold text-[14.4px] leading-[18px] text-SlateGray hover:text-topGreen cursor-pointer ${
                                isActive ? 'text-topGreen border-b pb-[4px] border-b-[2px] border-topGreen' : ''
                            }`;

                            return (
                                <li
                                    key={index}
                                    onClick={() => handleItemClick(index)}
                                    onMouseEnter={() => handleMenuHover(index)}
                                >
                                    {link.path ? (
                                        isExternal ? (
                                            <a href={link.path} target="_blank" rel="noopener noreferrer" className={linkClasses}>
                                                {link.label}
                                            </a>
                                        ) : (
                                            <Link to={link.path} className={linkClasses}>
                                                {link.label}
                                            </Link>
                                        )
                                    ) : (
                                        <span className={linkClasses}>{link.label}</span>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </Box>

                {/* Column 3 - Dynamic Content */}
                <Box className="px-6">
                    {activeItem !== null && (
                        <>
                            {links[activeItem]?.items ? (
                                <ul className="space-y-1">
                                    {links[activeItem].items.map((item, subIndex) => {
                                        const isExternalSub = item.path?.startsWith('http');
                                        const isActiveSub = activeSubItem === subIndex;

                                        const subLink = isExternalSub ? (
                                            <a
                                                href={item.path || '#'}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className={`font-manrope font-bold text-[14.4px] leading-[18px] text-SlateGray hover:text-topGreen ${
                                                    isActiveSub ? 'text-topGreen border-b pb-[10px] border-b-[3px] border-topGreen' : ''
                                                }`}
                                            >
                                                {item.label}
                                            </a>
                                        ) : (
                                            <Link
                                                to={item.path || '#'}
                                                className={`font-manrope font-bold text-[14.4px] leading-[18px] text-SlateGray hover:text-topGreen ${
                                                    isActiveSub ? 'text-topGreen border-b pb-[10px] border-b-[3px] border-topGreen' : ''
                                                }`}
                                            >
                                                {item.label}
                                            </Link>
                                        );

                                        return (
                                            <li key={subIndex} onClick={() => subItemhandleItemClick(subIndex)}>
                                                {item.label === 'Kasur Makhwat Program' ? (
                                                    <Link
                                                        to={item.path || '#'}
                                                        className="mt-9 block bg-ruralSecondary text-white font-manrope font-bold text-[14.4px] leading-[18px] p-4 rounded hover:bg-white"
                                                    >
                                                        <Box>
                                                            <CustomTypography as='p' variant='p3' weightFont='font-normal' color='text-SlateGray'>
                                                                RURAL DEVELOPMENT
                                                            </CustomTypography>
                                                            <CustomTypography className='pt-2' as='p' variant='p2' weightFont='font-normal' color='text-topGreen'>
                                                                {item.label}
                                                            </CustomTypography>
                                                        </Box>
                                                    </Link>
                                                ) : item.label === 'Mustafabad Program' ? (
                                                    <Link
                                                        to={item.path || '#'}
                                                        className="mt-2 block bg-MintCream text-white font-manrope font-bold text-[14.4px] leading-[18px] p-4 rounded hover:bg-white"
                                                    >
                                                        <Box>
                                                            <CustomTypography as='p' variant='p3' weightFont='font-normal' color='text-SlateGray'>
                                                                URBAN DEVELOPMENT
                                                            </CustomTypography>
                                                            <CustomTypography className='pt-2' as='p' variant='p2' weightFont='font-normal' color='text-topGreen'>
                                                                {item.label}
                                                            </CustomTypography>
                                                        </Box>
                                                    </Link>
                                                ) : (
                                                    subLink
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <>
                                    {links[activeItem]?.content && (
                                        <>
                                            {links[activeItem].content.image && (
                                                <img
                                                    src={getImagePath(links[activeItem].content.image)}
                                                    alt={links[activeItem].content.heading || 'Visual content'}
                                                    className="w-full h-[170px] object-cover rounded-lg"
                                                />
                                            )}
                                            <CustomTypography
                                                as="p"
                                                variant="p3"
                                                color="text-SlateGray"
                                                weightFont="font-semibold"
                                                className="mt-3"
                                            >
                                                {links[activeItem].content.heading || 'Heading Not Available'}
                                            </CustomTypography>
                                            <CustomTypography
                                                as="p"
                                                variant="p3"
                                                color="text-SlateGray"
                                                weightFont="font-normal"
                                            >
                                                {links[activeItem].content.detail || ''}
                                            </CustomTypography>
                                            {links[activeItem].content.buttonText && (
                                                links[activeItem].content.buttonLink?.startsWith('http') ? (
                                                   
                                                    <a
                                                        href={links[activeItem].content.buttonLink || '#'}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="mt-1 inline-block px-5 py-3 text-align:center font-manrope underline text-white  font-semibold text-[14.4px] bg-topGreen rounded-lg hover:bg-customGreen  "
                                                    >
                                                        {links[activeItem].content.buttonText || 'Read More'}
                                                    </a>
                                                  
                                                ) : (
                                                    <Link
                                                        to={links[activeItem].content.buttonLink || '#'}
                                                        className="t-1 inline-block px-5 py-3 text-align:center font-manrope underline text-white  font-semibold text-[14.4px] bg-topGreen rounded-lg hover:bg-customGreen  "
                                                    >
                                                        {links[activeItem].content.buttonText || 'Read More'}
                                                    </Link>
                                                )
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    )}
                </Box>
            </Box>
        </Box>
    );
}

export default Submenu;
